import { Icon } from '@chakra-ui/react';

export const Sort = (props) => (
  <Icon viewBox="0 0 20 21" boxSize="16px" color="icon.g1" {...props}>
    <path
      d="M10.0008 5.84661L12.6424 8.48828L13.8174 7.31328L10.0008 3.48828L6.17578 7.31328L7.35911 8.48828L10.0008 5.84661ZM10.0008 16.1299L7.35911 13.4883L6.18411 14.6633L10.0008 18.4883L13.8258 14.6633L12.6424 13.4883L10.0008 16.1299Z"
      fill="currentColor"
    />
  </Icon>
);
